import React from "react";

function FilterIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="7"
      fill="none"
      viewBox="0 0 12 7"
    >
      <path
        fill="#000"
        fillRule="evenodd"
        d="M4 6.5a.5.5 0 01.5-.5h3a.5.5 0 110 1h-3a.5.5 0 01-.5-.5zm-2-3a.5.5 0 01.5-.5h7a.5.5 0 110 1h-7a.5.5 0 01-.5-.5zm-2-3A.5.5 0 01.5 0h11a.5.5 0 010 1H.5A.5.5 0 010 .5z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default FilterIcon;
